import { OptionsType } from '@openx/types/options.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useOldDistributionChannelFetch() {
  const { t } = useTranslation();
  const {
    isLoading: isDistributionChannelLoading,
    data: distributionChannel,
    refetch: refetchDistributionChannel,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Distribution Channel options'),
    optionType: OptionsType.OLD_DISTRIBUTION_CHANNEL,
  });

  return {
    distributionChannel,
    isDistributionChannelLoading,
    refetchDistributionChannel,
  };
}
